import React from 'react';
import PropTypes from 'prop-types';

const IconLink = ({ className, iconInfo }) => {
  const { title, imageUrl, url } = iconInfo;
  return (
    <a
      href={url}
      className="block text-center no-underline"
      target="_blank"
      rel="noreferrer"
    >
      <figure
        className={`m-0 p-3 sm:p-5  bg-gray-200 rounded no-underline shadow hover:shadow-xl border border-transparent border-solid  hover:border-primary-main  transition duration-300 ease-in-out  text-primary-main ${
          className || ''
        }`}
      >
        <img
          className="w-10 md:w-12 lg:w-14 xl:w-16"
          src={imageUrl}
          alt={`${title} logo`}
        />

        <figcaption className="text-xs sm:text-sm md:text-base  font-normal">
          {title}
        </figcaption>
      </figure>
    </a>
  );
};

IconLink.propTypes = {
  className: PropTypes.string,
  iconInfo: PropTypes.object,
};

export default IconLink;
